<form [action]="ozowInitiateResponse.url" method="post" id="ozow-form" class="cdk-visually-hidden" hidden *ngIf="ozowInitiateResponse" target="output_frame">
    <input name="SiteCode" [value]="ozowInitiateResponse.siteCode" id="siteCode" hidden>
    <input name="CountryCode" [value]="ozowInitiateResponse.countryCode" id="countryCode" hidden>
    <input name="CurrencyCode" [value]="ozowInitiateResponse.currencyCode" id="currencyCode" hidden>
    <input name="Amount" [value]="ozowInitiateResponse.amount" id="amount" hidden>
    <input name="TransactionReference" [value]="ozowInitiateResponse.transactionId" id="transactionId" hidden>
    <input name="BankReference" [value]="ozowInitiateResponse.bankReference" id="bankReference" hidden>
    <input name="Customer" [value]="ozowInitiateResponse.customer" id="customer" hidden>
    <input name="CancelUrl" [value]="ozowInitiateResponse.cancelUrl" id="cancelUrl" hidden>
    <input name="ErrorUrl" [value]="ozowInitiateResponse.errorUrl" id="errorUrl" hidden>
    <input name="SuccessUrl" [value]="ozowInitiateResponse.successUrl" id="successUrl" hidden>
    <input name="NotifyUrl" [value]="ozowInitiateResponse.notifyUrl" id="notifyUrl" hidden>
    <input name="IsTest" [value]="ozowInitiateResponse.isTest" id="isTest" hidden>
    <input name="HashCheck" [value]="ozowInitiateResponse.hashCheck" id="hashCheck" hidden>
</form>

<div class="w-full h-full inline-block align-middle" *ngIf="!iframeLoaded && !iframePostback">
    <div class="flex justify-center w-full md:mt-11 pb-8">
        <img src="assets/icons/Icons/other-payment-options/payment-ozow_eft.png" alt="ozow logo">
    </div>
    <div class="flex justify-center pt-4 pb-6">
        <h3 class="text-center"><b>Please wait while you are redirected to OZOW<sup>TM</sup></b></h3>
    </div>  
    <div class="flex justify-center pt-4 pb-8" *ngIf="loading"> 
        <mat-spinner></mat-spinner>
    </div>
    <p class="subtext flex justify-center">Redirecting in <countdown class="text-lg ml-4" [config]="config"></countdown></p>
</div>
<div class="w-full h-full inline-block align-middle" *ngIf="!iframeLoaded && iframePostback">
    <div class="flex justify-center w-full md:mt-11 pb-8">
        <img src="assets/icons/Icons/other-payment-options/payment-ozow_eft.png" alt="ozow logo">
    </div>
    <div class="flex justify-center pt-4 pb-6">
        <h3 class="text-center"><b>Confirming Transaction Status</b></h3>
    </div>  
    <div class="flex justify-center pt-4 pb-8"> 
        <mat-spinner></mat-spinner>
    </div>
</div>
<iframe name="output_frame" class="external-iframe" [attr.data-loaded]="iframeLoaded" src="" #output_frame (load)="iframeOnLoad($event)"></iframe>
